import { render, staticRenderFns } from "./BotProgress.vue?vue&type=template&id=3925f05f&scoped=true"
import script from "./BotProgress.vue?vue&type=script&lang=js"
export * from "./BotProgress.vue?vue&type=script&lang=js"
import style0 from "./BotProgress.vue?vue&type=style&index=0&id=3925f05f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3925f05f",
  null
  
)

export default component.exports